/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberAppointmentsIdStart200, PostApiBarberAppointmentsIdStart400, PostApiBarberAppointmentsIdStart401, PostApiBarberAppointmentsIdStart403, PostApiBarberAppointmentsIdStart404, PostApiBarberAppointmentsIdStart500, PostApiBarberAppointmentsIdStartMutationResponse, PostApiBarberAppointmentsIdStartPathParams } from "../entities/PostApiBarberAppointmentsIdStart";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

export const postApiBarberAppointmentsIdStartPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<PostApiBarberAppointmentsIdStartPathParams>

/**
 * @description OK
 */
export const postApiBarberAppointmentsIdStart200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberAppointmentsIdStart200>

/**
 * @description Bad Request
 */
export const postApiBarberAppointmentsIdStart400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdStart400>

/**
 * @description Unauthorized
 */
export const postApiBarberAppointmentsIdStart401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdStart401>

/**
 * @description Forbidden
 */
export const postApiBarberAppointmentsIdStart403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdStart403>

/**
 * @description Not Found
 */
export const postApiBarberAppointmentsIdStart404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdStart404>

/**
 * @description Internal Server Error
 */
export const postApiBarberAppointmentsIdStart500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdStart500>

export const postApiBarberAppointmentsIdStartMutationResponseSchema = z.lazy(() => postApiBarberAppointmentsIdStart200Schema) as unknown as z.ZodType<PostApiBarberAppointmentsIdStartMutationResponse>